"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakeRewardDataset = void 0;
const interfaces_1 = require("@buildcore/interfaces");
const Dataset_1 = require("./Dataset");
/**
 * Stake Reward dataset.
 */
class StakeRewardDataset extends Dataset_1.DatasetClass {
    constructor() {
        super(...arguments);
        /**
         * Create stake reward.
         *
         * @param req Use {@link BuildcoreRequest} with data based on {@link TokenStakeRewardRequest}
         * @returns
         */
        this.create = (req) => this.sendRequest(interfaces_1.WEN_FUNC.stakeReward)(req);
        /**
         * Remove stake reward.
         *
         * @param req Use {@link BuildcoreRequest} with data based on {@link TokenStakeRewardsRemoveRequest}
         * @returns
         */
        this.remove = (req) => this.sendRequest(interfaces_1.WEN_FUNC.removeStakeReward)(req);
        /**
         * TODO
         *
         * @param token
         * @param startAfter
         * @returns
         */
        this.getByTokenLive = (token, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['token'],
                fieldValue: [token],
                operator: [interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: ['endDate'],
                orderByDir: ['asc'],
            };
            return this.getManyAdvancedLive(params);
        };
    }
}
exports.StakeRewardDataset = StakeRewardDataset;
